import { Dispatch } from "redux";
import { ActionType } from "../actions/ActionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import { GetUserProfile } from "./UserAction";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GenerateStory = (payload: object) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GENERATE_STORY_INIT });
      const url = `${BASE_URL}/story/create`;
      const response = await axios.post(url, payload);
      dispatch({
        type: ActionType.GENERATE_STORY_SUCCESS,
        payload: response.data,
      });
      const userId = localStorage.getItem("uid");
      if (userId) {
        dispatch(GetUserProfile(userId));
      }
      return true;
    } catch (error: any) {
      if (error.response?.status === 400 && error.response?.data?.errors) {
        // Handle validation errors
        const validationErrors = error.response.data.errors;
        console.error("Validation Errors:", validationErrors);

        dispatch({
          type: ActionType.GENERATE_STORY_FAIL,
          payload: validationErrors.map((err: any) => err.msg).join(", "),
        });
        toast.error(
          validationErrors.map((err: any) => err.msg).join(", ") ||
            "Error creating story, please try again later."
        );
        return false;
      } else {
        dispatch({
          type: ActionType.GENERATE_STORY_FAIL,
          payload: error.response?.data?.message || "Error creating story.",
        });
        toast.error(
          error.response?.data?.message ||
            "Error creating story, please try again later."
        );
        return false;
      }
    }
  };
};

// export const GenerateStory = (payload: object) => {
//   return async (dispatch: Dispatch<any>) => {
//     try {
//       dispatch({ type: Ac tionType.GENERATE_STORY_INIT });

//       const url = `${BASE_URL}/story/create`;
//       const response = await axios.post(url, payload);

//       const eventStreamUrl = response.data.eventStreamUrl || `${BASE_URL}/story/updates`;
//       const eventSource = new EventSource(eventStreamUrl);

//       eventSource.onmessage = (event) => {
//         const parsedData = JSON.parse(event.data);

//         if (parsedData.slide) {
//           dispatch({
//             type: ActionType.GENERATE_STORY_PROGRESS,
//             payload: parsedData,
//           });
//         } else if (parsedData.message === "Story creation complete" && parsedData.story) {
//           dispatch({
//             type: ActionType.GENERATE_STORY_SUCCESS,
//             payload: parsedData.story,
//           });
//           eventSource.close();
//         } else if (parsedData.message) {
//           toast.error(parsedData.message);
//           dispatch({
//             type: ActionType.GENERATE_STORY_FAIL,
//             payload: parsedData.message,
//           });
//           eventSource.close();
//         }
//       };

//       eventSource.onerror = (error: any) => {
//         toast.error("An error occurred while generating the story.");
//         dispatch({
//           type: ActionType.GENERATE_STORY_FAIL,
//           payload: error.message,
//         });
//         eventSource.close();
//       };
//     } catch (error: any) {
//       toast.error(
//         error.response?.data?.message || "An unexpected error occurred."
//       );
//       dispatch({
//         type: ActionType.GENERATE_STORY_FAIL,
//         payload: error.response?.data?.message || error.message,
//       });
//     }
//   };
// };

export const cancelStory = (storyId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.CANCEL_STORY_INIT });
      const url = `${BASE_URL}/story/cancel/${storyId}`;
      const response = await axios.delete(url);
      dispatch({
        type: ActionType.CANCEL_STORY_SUCCESS,
        payload: response.data,
      });
      toast.success("Story generation cancelled");
    } catch (error: any) {
      dispatch({
        type: ActionType.CANCEL_STORY_FAIL,
        payload: error.response?.data?.message || "Error cancelling story.",
      });
      toast.error("Failed to cancel story. Please try again later.");
    }
  };
};

export const DeleteStory = (storyId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.DELETE_STORY_INIT });

      const url = `${BASE_URL}/story/delete/${storyId}`;

      await axios.delete(url);
      dispatch({
        type: ActionType.DELETE_STORY_SUCCESS,
        payload: storyId,
      });
      dispatch(GetAllStories(localStorage.getItem("uid")!));
    } catch (error: any) {
      toast.error("Something went wrong!");

      dispatch({
        type: ActionType.DELETE_STORY_FAIL,
        payload: "Something went wrong!",
      });
    }
  };
};

export const GetStory = (StoryId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GET_SINGLE_STORY_INIT });
      const url = `${BASE_URL}/story/${encodeURIComponent(StoryId)}`;
      const response = await axios.get(url);

      dispatch({
        type: ActionType.GET_SINGLE_STORY_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      if (error.response.status === 404) {
        toast.error("Story not found");
        dispatch({
          type: ActionType.GET_SINGLE_STORY_FAIL,
          payload: "Story not found",
        });
      }
      toast.error("An unexpected error occurred");
      dispatch({
        type: ActionType.GET_SINGLE_STORY_FAIL,
        payload: "An unexpected error occurred",
      });
    }
  };
};

export const GetAllStories = (userId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GET_ALL_STORY_INIT });
      const url = `${BASE_URL}/story/user/${encodeURIComponent(userId)}`;
      const response = await axios.get(url);

      dispatch({
        type: ActionType.GET_ALL_STORY_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      if (error.response.status === 404) {
        dispatch({
          type: ActionType.GET_ALL_STORY_FAIL,
          payload: "No stories found for this user",
        });
      }
      dispatch({
        type: ActionType.GET_ALL_STORY_FAIL,
        payload: "An unexpected error occurred",
      });
    }
  };
};

export const editCaption = (
  storyId: string,
  slideNumber: number,
  newCaption: string
) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch({ type: ActionType.EDIT_CAPTION_INIT });
      // Call the API to update the caption
      const response = await axios.post(`${BASE_URL}/story/edit-caption`, {
        storyId,
        slideNumber,
        newCaption,
      });

      // Dispatch the success action with updated data
      dispatch({
        type: ActionType.EDIT_CAPTION,
        payload: { storyId, slideNumber, newCaption },
      });

      // toast.success("Caption updated successfully!");
    } catch (error) {
      dispatch({
        type: ActionType.EDIT_CAPTION_FAIL,
        payload: "An unexpected error occurred",
      });
      toast.error("Failed to update caption. Please try again.");
      console.error("Error updating caption:", error);
    }
  };
};

export const approveDenyRegeneratedStory = (payload: object) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch({ type: ActionType.APPROVE_REGENERATED_STORY_INIT });
      const response = await axios.post(
        `${BASE_URL}/story/approve-slide`,
        payload
      );

      dispatch({
        type: ActionType.APPROVE_REGENERATED_STORY_SUCCESS,
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: ActionType.APPROVE_REGENERATED_STORY_FAIL,
        payload: "An unexpected error occurred",
      });
      console.error("Failed to approve story slide");
    }
  };
};

export const resetStoryMessage = () => {
  return {
    type: ActionType.RESET_STORY_MESSAGE,
  };
};
